// Gradient background component for document and collection pages.

import React from 'react';
import { getGradientSurfaceStyle } from '@/styles/gradientSurfaceStyle';
import type { PlayerColorFamily } from '@/styles/playerColors';

interface BackgroundGradientProps {
  family: PlayerColorFamily;
  seed?: number;
  className?: string;
}

const BackgroundGradient: React.FC<BackgroundGradientProps> = ({
  family,
  seed,
  className,
}) => (
  <div
    className={
      className ??
      'document-gradient-surface document-gradient-surface--alive absolute inset-0'
    }
    style={getGradientSurfaceStyle(family, {
      motion: 'alive',
      seed,
    })}
    aria-hidden="true"
  />
);

export default BackgroundGradient;
